import { gql } from '@apollo/client';

export const getChannelList = gql`
  query channelList {
    channelList {
      television {
        category {
          channel {
            id
            name
          }
          id
          name
          numberOfChannels
          text
        }
      }
    }
  }
`;

export default getChannelList;
